import React from 'react'

import Select from 'react-select'
import AsyncSelect from 'react-select/async'
import { where } from 'firebase/firestore'

import { StepTitle } from './StepTitle'
import { IconPlusCircle } from '../../../icons/IconPlusCircle'
import { IconDelete2 } from '../../../icons/IconDelete2'

import { getUserFullName } from '../../../../helpers/helpers'
import { getConvertedData } from '../../../../models/interface.helper'

import FirestoreService from '../../../../services/firestoreService'

import { UserModel } from '../../../../models/users/user.model'

import { IRider } from '../../../../types/entryRider'
import { IOption } from '../../../inputs/InputNewMemberRow'
import { IUserInterface } from '../../../../models/users/user.interface'

import { customStyles } from '../../../customStyles/ReactSelectCustomStyle'
import { CONST } from '../../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

export interface INewMembers {
  member: IOption | null
  role: IOption | null
}

export type THandlerMemberType = 'role' | 'member'

interface IProps {
  currentRider: IRider
  newMembers: INewMembers[]
  updateHandlerNewMember: (index: number, itm: IOption, type: THandlerMemberType) => void
  addHandlerNewMember: () => void
  removeMemberHandler: (index: number) => void
  roles: IOption[]
}

export const SetTeamMembers: React.FC<IProps> = ({
  currentRider,
  newMembers,
  addHandlerNewMember,
  updateHandlerNewMember,
  removeMemberHandler,
  roles,
}) => {
  return (
    <>
      <StepTitle
        title={'Add team members'}
        desc={'Pegasus will automatically send team members liability paperwork to sign'}
      />
      <div className={'flex flex-col gap-3'}>
        <div className={'flex gap-3 w-full'}>
          <div className={'bg-[#F6F7FB] rounded flex items-center box-border h-[56px] flex-1'}>
            <span className={'text-[#122B4680] text-[14px] px-[17px] '}>
              {currentRider.riderName}
            </span>
          </div>
          <div className={'bg-[#F6F7FB] rounded flex box-border  items-center h-[56px] flex-[0.5]'}>
            <span className={'text-[#122B4680] text-[14px]  px-[17px]'}>Rider</span>
          </div>
          <div className={'w-[20px]'} />
        </div>
        {newMembers.map((itm, index) => (
          <div key={index} className={'flex gap-3 w-full'}>
            <AsyncSelect
              className={`border rounded-md w-40 !border-[#D3DAEE] flex-1 box-border`}
              isClearable={false}
              value={itm.member}
              onChange={(newMember) => {
                if (newMember) updateHandlerNewMember(index, newMember as IOption, 'member')
              }}
              styles={customStyles}
              isSearchable={true}
              isMulti={false}
              loadOptions={async (value) => {
                const search = value?.toLowerCase()?.replace(/\s+/g, '')
                const usersInDb: IUserInterface[] = []

                if (!search) return []

                const usersSnaps = await FirestoreService.filterItems(
                  COLLECTIONS.USERS_PUBLIC.NAME,
                  [
                    where(
                      COLLECTIONS.USERS_PUBLIC.FIELDS.USER_NAME_NGRAMS.KEY,
                      'array-contains',
                      search
                    ),
                  ]
                )

                usersSnaps.forEach((currDoc) => {
                  const current = getConvertedData(UserModel.fromFirestoreDoc(currDoc).toObject())
                  usersInDb.push(current)
                })

                return usersInDb.map((user) => ({
                  value: user.id,
                  label: getUserFullName(user),
                }))
              }}
              placeholder="Enter at least 3 letters..."
            />
            <Select
              isMulti={false}
              placeholder={<div className="flex text-[13px]">Role</div>}
              options={roles}
              onChange={(role) => {
                if (role) updateHandlerNewMember(index, role as IOption, 'role')
              }}
              value={itm.role}
              className={`border rounded-md w-40 !border-[#D3DAEE] flex-[0.5] box-border`}
              isClearable={false}
              styles={customStyles}
              isSearchable={true}
            />
            <button onClick={() => removeMemberHandler(index)}>
              <IconDelete2 />
            </button>
          </div>
        ))}

        <div className="flex justify-center mt-3">
          <button
            onClick={addHandlerNewMember}
            className="group flex gap-2 text-[#122B4680] hover:text-SeabiscuitMainThemeColor text-[12px] items-center"
          >
            <IconPlusCircle />
            <span className={'underline'}>Add person</span>
          </button>
        </div>
      </div>
    </>
  )
}
